
// SUIT CLUB – Perfect Sizefinder (v9)
// Based on v8 + new December size data and yellow-zone warning text.

var SIZEFINDER_ENDPOINT = "https://script.google.com/macros/s/AKfycbxF1rqeUR1YO-J9PSy2EzRps4aaGyEml0a9ceegTzl8kjeRrmQziwM_MkdKpDZc-JGN/exec";

(function () {
  // --- Data from Excel (December version) ---
  // sizeTable[heightRange][weightRange] = baseSize
  var sizeTable = {
  "170-175": {
    "45-49": 42,
    "50-54": 42,
    "55-59": 44,
    "60-64": 46,
    "65-69": 46,
    "70-74": 48,
    "75-79": 50,
    "80-86": 52,
    "87-89": 54,
    "90-94": 56,
    "95-99": 56,
    "100-105": 58,
    "106-111": 60,
    "112-120": 60,
    "121-126": 62,
    "127-133": 62
  },
  "176-180": {
    "45-49": 42,
    "50-54": 42,
    "55-59": 44,
    "60-64": 46,
    "65-69": 46,
    "70-74": 48,
    "75-79": 48,
    "80-86": 50,
    "87-89": 52,
    "90-94": 56,
    "95-99": 56,
    "100-105": 58,
    "106-111": 60,
    "112-120": 60,
    "121-126": 62,
    "127-133": 62
  },
  "181-185": {
    "45-49": 42,
    "50-54": 42,
    "55-59": 44,
    "60-64": 44,
    "65-69": 46,
    "70-74": 46,
    "75-79": 48,
    "80-86": 50,
    "87-89": 52,
    "90-94": 54,
    "95-99": 56,
    "100-105": 56,
    "106-111": 58,
    "112-120": 60,
    "121-126": 62,
    "127-133": 62
  },
  "186-190": {
    "45-49": 42,
    "50-54": 44,
    "55-59": 44,
    "60-64": 44,
    "65-69": 46,
    "70-74": 46,
    "75-79": 48,
    "80-86": 50,
    "87-89": 52,
    "90-94": 54,
    "95-99": 54,
    "100-105": 56,
    "106-111": 58,
    "112-120": 60,
    "121-126": 62,
    "127-133": 62
  },
  "191-192": {
    "45-49": 44,
    "50-54": 44,
    "55-59": 46,
    "60-64": 46,
    "65-69": 48,
    "70-74": 48,
    "75-79": 48,
    "80-86": 50,
    "87-89": 52,
    "90-94": 52,
    "95-99": 54,
    "100-105": 56,
    "106-111": 58,
    "112-120": 60,
    "121-126": 62,
    "127-133": 62
  },
  "193-195": {
    "45-49": 46,
    "50-54": 46,
    "55-59": 48,
    "60-64": 48,
    "65-69": 50,
    "70-74": 50,
    "75-79": 50,
    "80-86": 50,
    "87-89": 52,
    "90-94": 52,
    "95-99": 54,
    "100-105": 56,
    "106-111": 58,
    "112-120": 60,
    "121-126": 62,
    "127-133": 62
  },
  "196-200": {
    "45-49": 48,
    "50-54": 48,
    "55-59": 48,
    "60-64": 50,
    "65-69": 50,
    "70-74": 50,
    "75-79": 50,
    "80-86": 50,
    "87-89": 52,
    "90-94": 52,
    "95-99": 54,
    "100-105": 54,
    "106-111": 58,
    "112-120": 58,
    "121-126": 62,
    "127-133": 62
  },
  "201-210": {
    "45-49": 48,
    "50-54": 48,
    "55-59": 50,
    "60-64": 50,
    "65-69": 50,
    "70-74": 50,
    "75-79": 50,
    "80-86": 52,
    "87-89": 52,
    "90-94": 54,
    "95-99": 56,
    "100-105": 56,
    "106-111": 58,
    "112-120": 60,
    "121-126": 62,
    "127-133": 62
  }
};

  // yellowTable[heightRange][weightRange] = true if cell is in yellow zone
  var yellowTable = {
  "170-175": {
    "45-49": true,
    "50-54": true,
    "55-59": true,
    "60-64": true,
    "65-69": true,
    "70-74": true,
    "75-79": true,
    "80-86": true,
    "87-89": true,
    "90-94": true,
    "95-99": true,
    "100-105": true,
    "106-111": true,
    "112-120": true,
    "121-126": true,
    "127-133": true
  },
  "176-180": {
    "70-74": true,
    "75-79": true,
    "80-86": true,
    "87-89": true,
    "90-94": true,
    "95-99": true,
    "100-105": true,
    "106-111": true,
    "112-120": true,
    "121-126": true,
    "127-133": true
  },
  "181-185": {
    "90-94": true,
    "95-99": true,
    "100-105": true,
    "106-111": true,
    "112-120": true,
    "121-126": true,
    "127-133": true
  },
  "186-190": {
    "45-49": true,
    "50-54": true,
    "55-59": true,
    "60-64": true
  },
  "191-192": {
    "45-49": true,
    "50-54": true,
    "55-59": true,
    "60-64": true
  },
  "193-195": {
    "45-49": true,
    "50-54": true,
    "55-59": true,
    "60-64": true,
    "65-69": true,
    "70-74": true
  },
  "196-200": {
    "45-49": true,
    "50-54": true,
    "55-59": true,
    "60-64": true,
    "65-69": true,
    "70-74": true,
    "75-79": true,
    "80-86": true
  },
  "201-210": {
    "45-49": true,
    "50-54": true,
    "55-59": true,
    "60-64": true,
    "65-69": true,
    "70-74": true,
    "75-79": true,
    "80-86": true,
    "87-89": true,
    "90-94": true,
    "95-99": true,
    "100-105": true,
    "106-111": true,
    "112-120": true,
    "121-126": true,
    "127-133": true
  }
};

  function findRangeKeys(height, weight) {
    height = Number(height);
    weight = Number(weight);
    if (!height || !weight) return { hKey: null, wKey: null };

    var hKey = null;
    Object.keys(sizeTable).forEach(function (range) {
      var parts = String(range).split("-");
      if (parts.length !== 2) return;
      var min = parseFloat(parts[0].trim());
      var max = parseFloat(parts[1].trim());
      if (isNaN(min) || isNaN(max)) return;
      if (height >= min && height <= max) {
        if (!hKey) hKey = range;
      }
    });

    if (!hKey) return { hKey: null, wKey: null };
    var row = sizeTable[hKey];

    var wKey = null;
    Object.keys(row).forEach(function (range) {
      var parts = String(range).split("-");
      if (parts.length !== 2) return;
      var min = parseFloat(parts[0].trim());
      var max = parseFloat(parts[1].trim());
      if (isNaN(min) || isNaN(max)) return;
      if (weight >= min && weight <= max) {
        if (!wKey) wKey = range;
      }
    });

    return { hKey: hKey, wKey: wKey };
  }

  function lookupSize(height, weight) {
    var keys = findRangeKeys(height, weight);
    if (!keys.hKey || !keys.wKey) return "Book tid";
    var row = sizeTable[keys.hKey];
    var value = row[keys.wKey];
    if (typeof value === "number") return value;
    return "Book tid";
  }

  function isYellowZone(height, weight) {
    var keys = findRangeKeys(height, weight);
    if (!keys.hKey || !keys.wKey) return false;
    var row = yellowTable[keys.hKey] || {};
    return !!row[keys.wKey];
  }

  function createEl(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text != null) el.textContent = text;
    return el;
  }

  var STRINGS = {
    da: {
      step1Title: "Kropstal",
      heightPlaceholder: "Højde (cm)",
      weightPlaceholder: "Vægt (kg)",
      next: "Næste",
      seeResult: "Se resultat",
      back: "Tilbage",
      step2Title: "Alder (valgfrit)",
      agePlaceholder: "Skriv din alder (valgfrit)",
      step3Title: "Maveform",
      step4Title: "Skulder & bryst",
      step5Title: "Hofter & ben",
      shapeOptions: [
        { key: "thin", label: "Tynd" },
        { key: "normal", label: "Normal" },
        { key: "large", label: "Større" }
      ],
      step6Title: "Blazer fit",
      blazerFitOptions: [
        { key: "tight", label: "Tæt" },
        { key: "normal", label: "Normal" },
        { key: "loose", label: "Loose" }
      ],
      step7Title: "Bukse fit",
      pantsFitOptions: [
        { key: "slim", label: "Slim fit" },
        { key: "regular", label: "Regular fit" },
        { key: "straight", label: "Straight fit" },
        { key: "loose", label: "Loose fit" }
      ],
      resultTitle: "Din anbefalede størrelse",
      noMatchText: "Ud fra dine mål anbefaler vi, at du booker tid i butikken, så vi kan hjælpe dig personligt.",
      blazerLabel: "Blazer",
      pantsLabel: "Bukser",
      yellowZoneHtml:
        "<strong>OBS - Mulig tilpasning</strong><br>" +
        "For optimal pasform anbefaler vi at få vurderet, om længde eller andre detaljer bør tilpasses. " +
        "Besøg vores butikker for professionel rådgivning eller din lokale skrædder.",
      infoHtml:
        "Vores sizefinder er udviklet ud fra data fra mere end 30.000 mænd.<br>" +
        "Du kan altid bytte eller returnere, hvis det ikke passer - så vælg den størrelse, vi anbefaler.<br>" +
        "Levering i Danmark 1-2 dage.<br>" +
        "Tak for din tillid.",
      restart: "Start forfra",
      close: "Luk size-finder"
    },
    de: {
      step1Title: "Körpermaße",
      heightPlaceholder: "Größe (cm)",
      weightPlaceholder: "Gewicht (kg)",
      next: "Weiter",
      seeResult: "Ergebnis ansehen",
      back: "Zurück",
      step2Title: "Alter (optional)",
      agePlaceholder: "Gib dein Alter ein (optional)",
      step3Title: "Bauchform",
      step4Title: "Schulter & Brust",
      step5Title: "Hüfte & Beine",
      shapeOptions: [
        { key: "thin", label: "Schmal" },
        { key: "normal", label: "Normal" },
        { key: "large", label: "Größer" }
      ],
      step6Title: "Blazer Fit",
      blazerFitOptions: [
        { key: "tight", label: "Eng" },
        { key: "normal", label: "Normal" },
        { key: "loose", label: "Loose" }
      ],
      step7Title: "Hosen Fit",
      pantsFitOptions: [
        { key: "slim", label: "Slim fit" },
        { key: "regular", label: "Regular fit" },
        { key: "straight", label: "Straight fit" },
        { key: "loose", label: "Loose fit" }
      ],
      resultTitle: "Deine empfohlene Größe",
      noMatchText: "Basierend auf deinen Maßen empfehlen wir dir, einen Termin im Geschäft zu vereinbaren, damit wir dir persönlich helfen können.",
      blazerLabel: "Blazer",
      pantsLabel: "Hosen",
      yellowZoneHtml:
        "<strong>HINWEIS – Mögliche Anpassung</strong><br>" +
        "Für die optimale Passform empfehlen wir, prüfen zu lassen, ob die Länge oder andere Details angepasst werden sollten. " +
        "Besuche unsere Filialen für eine professionelle Beratung oder wende dich an deinen örtlichen Schneider.",
      infoHtml:
        "Unser Size-Finder wurde auf Basis von Daten von über 30.000 Männern entwickelt.<br>" +
        "Du kannst jederzeit umtauschen oder zurücksenden, falls es nicht passt – wähle also einfach die von uns empfohlene Größe.<br>" +
        "Die Versandkosten werden an der Kasse berechnet.<br>" +
        "Vielen Dank für dein Vertrauen.",
      restart: "Neu starten",
      close: "Size-Finder schließen"
    }
  };

  window.initSizeFinder = function (containerId, locale) {
    var root = document.getElementById(containerId);
    if (!root) return;

    // Widgettens tekst er som udgangspunkt dansk (uændret adfærd på alle
    // markeder). Kun når siden eksplicit er på det tyske sprog ("de", fx
    // /de-de) skifter vi til de tyske strenge. locale kommer fra
    // {{ request.locale.iso_code }} i layout/theme.liquid, som er
    // locale-stabil (i modsætning til fx product.title).
    var STR = (locale === "de") ? STRINGS.de : STRINGS.da;

    var state = {
      step: 1,
      height: "",
      weight: "",
      age: "",
      mave: null,
      skulder: null,
      hofter: null,
      blazerFit: null,
      pantsFit: null,
      baseSize: null,
      isYellow: false,
      hasSentAnalytics: false
    };

    // Analytics til Google Sheets
    function sendSizefinderData() {
      if (!SIZEFINDER_ENDPOINT) return;
      try {
        var payload = {
          height: state.height,
          weight: state.weight,
          age: state.age,
          mave: state.mave,
          skulder: state.skulder,
          hofter: state.hofter,
          blazerFit: state.blazerFit,
          pantsFit: state.pantsFit,
          baseSize: state.baseSize,
          blazerSize: getBlazerSize(),
          pantsSize: getPantsSize(),
          yellowZone: state.isYellow
        };

        fetch(SIZEFINDER_ENDPOINT, {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });
      } catch (e) {
        if (console && console.warn) console.warn("Sizefinder analytics error", e);
      }
    }

    function getBlazerSize() {
      var base = state.baseSize;
      if (!base || base === "Book tid") return base || null;
      // +1/-1 betyder spring til næste/næste mindre størrelse: 48 -> 50 osv.
      if (state.blazerFit === "tight") return base - 2;
      if (state.blazerFit === "loose") return base + 2;
      return base;
    }

    function getPantsSize() {
      var base = state.baseSize;
      if (!base || base === "Book tid") return base || null;
      if (state.pantsFit === "slim") return base - 2;
      if (state.pantsFit === "regular") return base;
      if (state.pantsFit === "straight") return base;
      if (state.pantsFit === "loose") return base + 2; // +1 størrelse + straight fit
      return base;
    }

    function clearRoot() {
      while (root.firstChild) root.removeChild(root.firstChild);
    }

    function render() {
      clearRoot();

      var wrapper = createEl("div", "sc-wrapper");
      root.appendChild(wrapper);

      wrapper.style.maxWidth = "480px";
      wrapper.style.margin = "0 auto";
      wrapper.style.fontFamily = "system-ui, -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif";
      wrapper.style.color = "#111";
      wrapper.style.padding = "1.5rem";
      wrapper.style.boxSizing = "border-box";

      if (state.step === 1) {
        renderHeaderAndProgress(wrapper, STR.step1Title, state.step);
        renderStep1(wrapper);
      } else if (state.step === 2) {
        renderHeaderAndProgress(wrapper, STR.step2Title, state.step);
        renderAgeStep(wrapper);
      } else if (state.step === 3) {
        renderShapeStep(wrapper, STR.step3Title, "mave");
      } else if (state.step === 4) {
        renderShapeStep(wrapper, STR.step4Title, "skulder");
      } else if (state.step === 5) {
        renderShapeStep(wrapper, STR.step5Title, "hofter");
      } else if (state.step === 6) {
        renderBlazerFit(wrapper);
      } else if (state.step === 7) {
        renderPantsFit(wrapper);
      } else if (state.step === 8) {
        renderResult(wrapper);
      }
    }

    function renderStep1(wrapper) {
      var heightInput = createEl("input");
      heightInput.type = "number";
      heightInput.placeholder = STR.heightPlaceholder;
      heightInput.value = state.height;
      styleInput(heightInput);
      wrapper.appendChild(heightInput);

      var spacer = createEl("div");
      spacer.style.height = "12px";
      wrapper.appendChild(spacer);

      var weightInput = createEl("input");
      weightInput.type = "number";
      weightInput.placeholder = STR.weightPlaceholder;
      weightInput.value = state.weight;
      styleInput(weightInput);
      wrapper.appendChild(weightInput);

      var button = createEl("button", null, STR.next);
      stylePrimaryButton(button);
      button.style.marginTop = "20px";
      button.style.borderRadius = "5px";

      function updateNextState() {
        var enabled = Number(state.height) > 0 && Number(state.weight) > 0;
        button.disabled = !enabled;
        button.style.opacity = enabled ? "1" : "0.5";
        button.style.cursor = enabled ? "pointer" : "not-allowed";
      }

      heightInput.oninput = function () {
        state.height = heightInput.value;
        updateNextState();
      };
      weightInput.oninput = function () {
        state.weight = weightInput.value;
        updateNextState();
      };

      updateNextState();

      button.onclick = function () {
        if (button.disabled) return;
        state.baseSize = lookupSize(state.height, state.weight);
        state.isYellow = isYellowZone(state.height, state.weight);
        state.step = 2;
        render();
      };
      wrapper.appendChild(button);
    }

    

    function renderAgeStep(wrapper) {
      var ageInput = createEl("input");
      ageInput.type = "number";
      ageInput.placeholder = STR.agePlaceholder;
      ageInput.value = state.age;
      styleInput(ageInput);
      ageInput.oninput = function () {
        state.age = ageInput.value;
      };
      wrapper.appendChild(ageInput);

      if (state.step > 1 && state.step <= 8) {
        var backBtn = createEl("button", "sc-back", STR.back);
        backBtn.style.border = "none";
        backBtn.style.background = "transparent";
        backBtn.style.color = "#666";
        backBtn.style.fontSize = "12px";
        backBtn.style.textDecoration = "underline";
        backBtn.style.marginBottom = "12px";
        backBtn.style.cursor = "pointer";
        backBtn.onclick = function () {
          state.step = Math.max(1, state.step - 1);
          render();
        };
        wrapper.appendChild(backBtn);
      }

      var nextBtn = createEl("button", null, STR.next);
      stylePrimaryButton(nextBtn);
      nextBtn.style.marginTop = "";
      nextBtn.style.borderRadius = "5px";
      nextBtn.onclick = function () {
        state.step = 3;
        render();
      };
      wrapper.appendChild(nextBtn);
    }

    function styleInput(inp) {
      inp.style.width = "100%";
      inp.style.height = "56px";
      inp.style.padding = "0 16px";
      inp.style.borderRadius = "5px";
      inp.style.border = "none";
      inp.style.backgroundColor = "#f5f5f5";
      inp.style.fontSize = "14px";
      inp.style.boxSizing = "border-box";
    }

    function stylePrimaryButton(btn) {
      btn.style.width = "100%";
      btn.style.height = "56px";
      btn.style.padding = "0 18px";
      btn.style.borderRadius = "5px";
      btn.style.border = "none";
      btn.style.backgroundColor = "#000";
      btn.style.color = "#fff";
      btn.style.fontSize = "14px";
      btn.style.fontWeight = "500";
      btn.style.cursor = "pointer";
    }

    function styleCardButton(btn, active) {
      btn.style.padding = "16px 12px";
      btn.style.borderRadius = "5px";
      btn.style.border = "none";
      btn.style.backgroundColor = active ? "#111" : "#f5f5f5";
      btn.style.color = active ? "#fff" : "#111";
      btn.style.fontSize = "13px";
      btn.style.cursor = "pointer";
      btn.style.display = "flex";
      btn.style.flexDirection = "column";
      btn.style.alignItems = "center";
      btn.style.justifyContent = "center";
      btn.style.gap = "8px";
    }

    function renderHeaderAndProgress(wrapper, title, stepOverride) {
      var totalSteps = 7;
      var currentStep = stepOverride != null ? stepOverride : state.step;
      if (currentStep > totalSteps) currentStep = totalSteps;
      if (currentStep < 1) currentStep = 1;

      var headerRow = createEl("div");
      headerRow.style.display = "flex";
      headerRow.style.alignItems = "center";
      headerRow.style.justifyContent = "space-between";
      headerRow.style.marginBottom = "8px";

      var h = createEl("h1", null, title);
      h.style.fontSize = "24px";
      h.style.fontWeight = "500";
      h.style.margin = "0";
      headerRow.appendChild(h);

      var label = createEl("div", null, currentStep + "/" + totalSteps);
      label.style.fontSize = "12px";
      label.style.color = "#555";
      headerRow.appendChild(label);

      wrapper.appendChild(headerRow);

      var bar = createEl("div");
      bar.style.display = "flex";
      bar.style.flexWrap = "nowrap";
      bar.style.alignItems = "center";
      bar.style.gap = "6px";
      bar.style.width = "100%";
      bar.style.marginBottom = "16px";

      for (var i = 1; i <= totalSteps; i++) {
        var seg = createEl("div");
        seg.className = "cm-progress-step";
        seg.style.flex = "1";
        seg.style.height = "6px";
        seg.style.borderRadius = "999px";
        seg.style.backgroundColor = i <= currentStep ? "#121e35" : "#e0e0e0";
        bar.appendChild(seg);
      }

      wrapper.appendChild(bar);
    }

    function renderShapeStep(wrapper, title, field) {
      renderHeaderAndProgress(wrapper, title, state.step);

      var grid = createEl("div");
      grid.style.display = "grid";
      grid.style.gridTemplateColumns = "repeat(3, minmax(0, 1fr))";
      grid.style.gap = "12px";
      wrapper.appendChild(grid);

      STR.shapeOptions.forEach(function (opt) {
        var value = opt.key;
        var label = opt.label;
        var current = state[field];
        var btn = createEl("button", null, "");
        var active = current === value;
        styleCardButton(btn, active);

        var icon = createEl("div");
        icon.style.width = "60px";
        icon.style.height = "60px";
        icon.style.borderRadius = "50%";
        icon.style.backgroundColor = active ? "#fff" : "#d0d0d0";
        icon.style.marginBottom = "6px";
        icon.style.position = "relative";

        var head = createEl("div");
        head.style.width = "34%";
        head.style.height = "34%";
        head.style.borderRadius = "50%";
        head.style.backgroundColor = active ? "#111" : "#777";
        head.style.position = "absolute";
        head.style.top = "16%";
        head.style.left = "50%";
        head.style.transform = "translateX(-50%)";
        icon.appendChild(head);

        var body = createEl("div");
        body.style.width = value === "thin" ? "30%" : value === "normal" ? "44%" : "60%";
        body.style.height = "38%";
        body.style.borderRadius = "45%";
        body.style.backgroundColor = active ? "#111" : "#777";
        body.style.position = "absolute";
        body.style.bottom = "10%";
        body.style.left = "50%";
        body.style.transform = "translateX(-50%)";
        icon.appendChild(body);

        btn.appendChild(icon);

        var text = createEl("span", null, label);
        text.style.fontSize = "13px";
        text.style.fontWeight = "500";
        btn.appendChild(text);

        btn.onclick = function () {
          state[field] = value;
          render();
        };
        grid.appendChild(btn);
      });

      if (state.step > 1 && state.step <= 8) {
        var backBtn = createEl("button", "sc-back", STR.back);
        backBtn.style.border = "none";
        backBtn.style.background = "transparent";
        backBtn.style.color = "#666";
        backBtn.style.fontSize = "12px";
        backBtn.style.textDecoration = "underline";
        backBtn.style.marginBottom = "12px";
        backBtn.style.cursor = "pointer";
        backBtn.onclick = function () {
          state.step = Math.max(1, state.step - 1);
          render();
        };
        wrapper.appendChild(backBtn);
      }

      var nextBtn = createEl("button", null, STR.next);
      stylePrimaryButton(nextBtn);
      nextBtn.style.marginTop = "";
      nextBtn.style.borderRadius = "5px";
      nextBtn.onclick = function () {
        state.step += 1;
        render();
      };
      wrapper.appendChild(nextBtn);
    }

    function renderBlazerFit(wrapper) {
      renderHeaderAndProgress(wrapper, STR.step6Title, state.step);

      var grid = createEl("div");
      grid.style.display = "grid";
      grid.style.gridTemplateColumns = "repeat(3, minmax(0, 1fr))";
      grid.style.gap = "12px";
      wrapper.appendChild(grid);

      STR.blazerFitOptions.forEach(function (opt) {
        var btn = createEl("button", null, "");
        var active = state.blazerFit === opt.key;
        styleCardButton(btn, active);

        var text = createEl("span", null, opt.label);
        text.style.fontSize = "13px";
        text.style.fontWeight = "500";
        btn.appendChild(text);

        btn.onclick = function () {
          state.blazerFit = opt.key;
          render();
        };
        grid.appendChild(btn);
      });

      if (state.step > 1 && state.step <= 8) {
        var backBtn = createEl("button", "sc-back", STR.back);
        backBtn.style.border = "none";
        backBtn.style.background = "transparent";
        backBtn.style.color = "#666";
        backBtn.style.fontSize = "12px";
        backBtn.style.textDecoration = "underline";
        backBtn.style.marginBottom = "12px";
        backBtn.style.cursor = "pointer";
        backBtn.onclick = function () {
          state.step = Math.max(1, state.step - 1);
          render();
        };
        wrapper.appendChild(backBtn);
      }

      var nextBtn = createEl("button", null, STR.next);
      stylePrimaryButton(nextBtn);
      nextBtn.style.marginTop = "";
      nextBtn.style.borderRadius = "5px";
      nextBtn.onclick = function () {
        state.step = 7;
        render();
      };
      wrapper.appendChild(nextBtn);
    }

    function renderPantsFit(wrapper) {
      renderHeaderAndProgress(wrapper, STR.step7Title, state.step);

      var grid = createEl("div");
      grid.style.display = "grid";
      grid.style.gridTemplateColumns = "repeat(2, minmax(0, 1fr))";
      grid.style.gap = "12px";
      wrapper.appendChild(grid);

      STR.pantsFitOptions.forEach(function (opt) {
        var btn = createEl("button");
        var active = state.pantsFit === opt.key;

        styleCardButton(btn, active);
        btn.style.alignItems = "flex-start";
        btn.style.textAlign = "left";

        var title = createEl("div", null, opt.label);
        title.style.fontWeight = "600";
        title.style.fontSize = "13px";
        btn.appendChild(title);

        btn.onclick = function () {
          state.pantsFit = opt.key;
          render();
        };

        grid.appendChild(btn);
      });

      if (state.step > 1 && state.step <= 8) {
        var backBtn = createEl("button", "sc-back", STR.back);
        backBtn.style.border = "none";
        backBtn.style.background = "transparent";
        backBtn.style.color = "#666";
        backBtn.style.fontSize = "12px";
        backBtn.style.textDecoration = "underline";
        backBtn.style.marginBottom = "12px";
        backBtn.style.cursor = "pointer";
        backBtn.onclick = function () {
          state.step = Math.max(1, state.step - 1);
          render();
        };
        wrapper.appendChild(backBtn);
      }

      var nextBtn = createEl("button", null, STR.seeResult);
      stylePrimaryButton(nextBtn);
      nextBtn.style.marginTop = "";
      nextBtn.style.borderRadius = "5px";
      nextBtn.onclick = function () {
        state.step = 8;
        render();
      };
      wrapper.appendChild(nextBtn);
    }

    function styleResultBox(container) {
      container.style.padding = "16px 12px";
      container.style.borderRadius = "5px";
      container.style.border = "none";
      container.style.backgroundColor = "#f5f5f5";
      container.style.display = "flex";
      container.style.flexDirection = "column";
      container.style.alignItems = "center";
      container.style.justifyContent = "center";
      container.style.gap = "4px";
      container.style.fontSize = "13px";
      container.style.textAlign = "center";
      container.style.minHeight = "80px";
      container.style.boxSizing = "border-box";
    }

    
    function renderResult(wrapper) {
      renderHeaderAndProgress(wrapper, STR.resultTitle, 7);

      if (state.baseSize === "Book tid" || !state.baseSize) {
        var p = createEl("p", null, STR.noMatchText);
        p.style.fontSize = "14px";
        p.style.textAlign = "left";
        p.style.marginBottom = "16px";
        wrapper.appendChild(p);
        } else {
    var blazerSize = getBlazerSize();
    var pantsSize = getPantsSize();

    if (!state.hasSentAnalytics) {
      sendSizefinderData();
      state.hasSentAnalytics = true;

      // --- NYT: Send data til draweren ---
      const sizeEvent = new CustomEvent('cm:sizefinder:result', {
        detail: {
          blazer: blazerSize,
          pants: pantsSize,
          vest: blazerSize, // Vest følger typisk blazer-størrelsen
          pantsFit: state.pantsFit
        }
      });
      document.dispatchEvent(sizeEvent);
      }

        var cards = createEl("div");
        cards.style.display = "grid";
        cards.style.gridTemplateColumns = "repeat(2, minmax(0, 1fr))";
        cards.style.gap = "4px";
        cards.style.marginBottom = "16px";
        cards.style.alignItems = "stretch";
        wrapper.appendChild(cards);

        var blazerBox = createEl("div");
        styleResultBox(blazerBox);
        var blazerTitle = createEl("div", null, STR.blazerLabel);
        blazerTitle.style.fontWeight = "600";
        var blazerValue = createEl("div", null, blazerSize ? String(blazerSize) : "-");
        blazerValue.style.fontSize = "22px";
        blazerValue.style.fontWeight = "600";
        blazerBox.appendChild(blazerTitle);
        blazerBox.appendChild(blazerValue);
        cards.appendChild(blazerBox);

        var pantsBox = createEl("div");
        styleResultBox(pantsBox);
        var pantsTitle = createEl("div", null, STR.pantsLabel);
        pantsTitle.style.fontWeight = "600";
        var pantsText = pantsSize ? String(pantsSize) : "-";
        if (state.pantsFit && pantsSize && pantsSize !== "Book tid") {
          var fitLabel = state.pantsFit === "loose" ? "straight" : state.pantsFit;
          pantsText += " (" + fitLabel + " fit)";
        }
        var pantsValue = createEl("div", null, pantsText);
        pantsValue.style.fontSize = "22px";
        pantsValue.style.fontWeight = "600";
        pantsBox.appendChild(pantsTitle);
        pantsBox.appendChild(pantsValue);
        cards.appendChild(pantsBox);

        if (state.isYellow) {
          var obs = createEl("div");
          obs.style.fontSize = "13px";
          obs.style.color = "#111";
          obs.style.marginBottom = "8px";
          obs.style.textAlign = "left";
          obs.style.fontWeight = "400";
          obs.innerHTML = STR.yellowZoneHtml;
          wrapper.appendChild(obs);
        }
      }

      var info = createEl("div");
      info.style.fontSize = "12px";
      info.style.color = "#555";
      info.style.marginTop = "8px";
      info.style.textAlign = "left";

      info.innerHTML = STR.infoHtml;

      wrapper.appendChild(info);

      var restart = createEl("button", null, STR.restart);
      stylePrimaryButton(restart);
      restart.style.marginTop = "20px";
      restart.style.borderRadius = "5px";
      restart.style.backgroundColor = "white";
      restart.style.color = "black";
      restart.style.border = "1px solid rgb(211, 211, 211)";
      restart.onclick = function () {
        state.step = 1;
        state.height = "";
        state.weight = "";
        state.age = "";
        state.mave = null;
        state.skulder = null;
        state.hofter = null;
        state.blazerFit = null;
        state.pantsFit = null;
        state.baseSize = null;
        state.isYellow = false;
        state.hasSentAnalytics = false;
        render();
      };
      wrapper.appendChild(restart);
      // --- NY: Luk sizefinder knap ---
      var closeBtn = createEl("button", null, STR.close);
      closeBtn.style.width = "100%";
      closeBtn.style.padding = "14px";
      closeBtn.style.marginTop = "10px";
      closeBtn.style.border = "none";
      closeBtn.style.background = "#000";
      closeBtn.style.color = "#fff";
      closeBtn.style.borderRadius = "5px";
      closeBtn.style.cursor = "pointer";
      closeBtn.style.fontSize = "14px";
      closeBtn.style.height = "56px";
      
      closeBtn.onclick = function() {
        var modal = document.getElementById('cm-cart-sizefinder-modal');
        if (modal) {
          if (typeof modal.close === 'function') {
            modal.close();
          } else {
            modal.style.display = 'none';
          }
        }
        
        // Hvis din container også har en display-værdi der skal nulstilles, kan du beholde dette:
        var sfContainer = document.getElementById('cm-sizefinder-container');
        if (sfContainer) {
          sfContainer.style.display = 'none';
        }
      };
      wrapper.appendChild(closeBtn);
    }

    render();

  };
})();
